module.exports = __webpack_public_path__ + "img/TeamComic_041.45ee39ef.png";